module.exports = __webpack_public_path__ + "img/传统生产3.945a56b8.png";